import { NgModule } from '@angular/core';
import { MultiLocationComponent } from './multi-location/multi-location';
import { AgmCoreModule } from '@agm/core';
import { CommonModule } from '@angular/common';
@NgModule({
	declarations: [
		MultiLocationComponent
	],
	imports: [
		CommonModule,
		AgmCoreModule.forRoot({
			apiKey: 'AIzaSyBqQDcH2FfuB5tg_3cdhFtc4nGuKcz79uM',
			libraries: ["places"]
		}),
		
	],
	exports: [MultiLocationComponent]
})
export class ComponentsModule { }



// WEBPACK FOOTER //
// ./src/components/components.module.ts